import React from "react";
import { Form, Input } from "antd";
import { NumericFormat } from "react-number-format";
import {
  allowOnlyNumbers,
  allowOnlyNumberswithMaxLimit,
  allowOnlyPressesNumbersWithMaxLimit
} from "../services/common.service";

const CustomNumberInputEMI = ({
  name,
  label,
  maxLimit,
  minLimit,
  allowNegative = false,
  thousandsSeparator = true,
  thousandsGroupStyle = "lakh",
  prefix,
  suffix,
  size = "large",
  onChange,
  allowLeadingZeros = false,
  disabled,
}) => {
  const handleValueChange = (values) => {
    if (typeof values.value === "string") {
      const newValue = Number(values.value.replace(/[^0-9]/g, ""));
        onChange(newValue);
    }
  };

  const allowOnlyNumberswithMinLimit = (value) => {
    if (typeof value === "string") {
      const newValue = Number(value.replace(/[^0-9]/g, ""));
      if (newValue < minLimit) {
        onChange(minLimit);
      }
    }
  };

  return (
    <Form.Item name={name} label={label}>
      <NumericFormat
        allowNegative={allowNegative}
        customInput={Input}
        thousandSeparator={thousandsSeparator}
        // thousandsGroupStyle={thousandsGroupStyle}
        onValueChange={handleValueChange}
        addonBefore={prefix}
        suffix={suffix}
        size={size}
        onBlur={(e) => allowOnlyNumberswithMinLimit(e.target.value)}
        disabled={disabled}
        allowLeadingZeros={allowLeadingZeros}
      />
    </Form.Item>
  );
};

export default CustomNumberInputEMI;
